// QR menyu mövsümi temaları: superadmin → Ayarlar → «QR menyu: mövsümi tema».
// Seçilən tema bütün tenantlarda görünür. Bəzəklər yalnız dekorasiyadır: pointer-events yoxdur,
// kənarlarda qalır ki, mətni örtməsin. Rənglər backend-dəki SEASON_THEMES (routes/menu.js) ilə eynidir.

export const SEASON_THEMES = {
    halloween: { primary: '#f97316', bg: '#1a1024', cover_overlay: 'blue', cover_overlay_opacity: 8 },
    newyear:   { primary: '#dc2626', bg: '#0b1a33', cover_overlay: 'blue', cover_overlay_opacity: 8 },
    novruz:    { primary: '#16a34a', bg: '#0f241a', cover_overlay: 'blue', cover_overlay_opacity: 8 },
};
export const isSeason = (s) => Object.prototype.hasOwnProperty.call(SEASON_THEMES, s);

// ── Ümumi animasiyalar ────────────────────────────────────────────────────────
const BASE_CSS = `
    @keyframes qsBob  { 0%,100% { transform: translateY(0) rotate(-4deg); } 50% { transform: translateY(-8px) rotate(4deg); } }
    @keyframes qsFall { 0% { transform: translate3d(0,-8vh,0) rotate(0deg); } 100% { transform: translate3d(var(--qs-dx, 0px),108vh,0) rotate(360deg); } }
    .qs-bob  { animation: qsBob 4s ease-in-out infinite; }
    .qs-fall { position: absolute; top: 0; animation: qsFall linear infinite; will-change: transform; }
    @media (prefers-reduced-motion: reduce) {
        .qs-anim, .qs-anim * { animation: none !important; }
        .qs-fall, .hw-bat { display: none; }
    }
`;

// Sabit «təsadüfi» düzülüş (hər açılışda eyni, render-də sıçrama olmasın)
const scatter = (n, seed) => Array.from({ length: n }, (_, i) => {
    const r = (k) => { const x = Math.sin((i + 1) * 9301 + seed * 49297 + k * 233) * 10000; return x - Math.floor(x); };
    return { left: `${Math.round(r(1) * 100)}%`, size: 8 + Math.round(r(2) * 12), dur: 9 + Math.round(r(3) * 10), delay: -Math.round(r(4) * 18), dx: Math.round((r(5) - 0.5) * 80), op: 0.45 + r(6) * 0.45 };
});

// ═════════════════════════════════ HALLOWEEN ═════════════════════════════════

const Bat = ({ className, style }) => (
    <svg viewBox="0 0 64 32" className={className} style={style} aria-hidden="true">
        <path fill="currentColor" d="M32 10c-1.6-3-3-4.2-3-4.2s.6 2.6-.4 4.4c-3.4-.6-6.4-3.6-9.6-4.2-3.6-.7-7 1-9.4 3.6C7 12 4.6 12.6 0 12c4 2 6 5 6.4 8.6 2.4-2.4 5.8-2.8 8.6-1.2 1.2-2.6 4-3.8 6.8-3 .8-2 2.6-3.4 4.8-3.4C28.4 15.4 30 18 32 22c2-4 3.6-6.6 5.4-9 2.2 0 4 1.4 4.8 3.4 2.8-.8 5.6.4 6.8 3 2.8-1.6 6.2-1.2 8.6 1.2.4-3.6 2.4-6.6 6.4-8.6-4.6.6-7 0-9.6-2.4-2.4-2.6-5.8-4.3-9.4-3.6-3.2.6-6.2 3.6-9.6 4.2-1-1.8-.4-4.4-.4-4.4S33.6 7 32 10z" />
    </svg>
);

const Pumpkin = ({ className, style }) => (
    <svg viewBox="0 0 64 60" className={className} style={style} aria-hidden="true">
        <path d="M33 12c0-5 3-9 7-10l1.6 2.6C38 6 36.4 8.6 36.4 12z" fill="#4d7c0f" />
        <ellipse cx="18" cy="35" rx="15" ry="20" fill="#ea580c" />
        <ellipse cx="46" cy="35" rx="15" ry="20" fill="#ea580c" />
        <ellipse cx="32" cy="35" rx="15" ry="22" fill="#f97316" />
        <path d="M19 30l7-5 2 8zM45 30l-7-5-2 8z" fill="#2b1406" />
        <path d="M18 41c4 6 10 8 14 8s10-2 14-8l-4 1-2 3-3-2-5 3-5-3-3 2-2-3z" fill="#2b1406" />
    </svg>
);

const Web = ({ className, style }) => (
    <svg viewBox="0 0 100 100" className={className} style={style} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="0.9">
        <path d="M0 0L100 30M0 0L80 60M0 0L55 85M0 0L28 100M0 0L0 100M0 0L100 0" />
        <path d="M0 18Q9 13 18 0M0 36Q19 30 25 22Q32 12 36 0M0 56Q20 50 34 40Q48 26 55 0M0 76Q24 70 44 56Q62 40 74 0M0 96Q30 90 54 72Q78 52 92 2" />
    </svg>
);

const Spider = ({ className, style }) => (
    <div className={className} style={style} aria-hidden="true">
        <div className="mx-auto h-16 w-px bg-white/40" />
        <svg viewBox="0 0 40 30" className="h-7 w-9 text-[#1b1024]">
            <g stroke="#e9d5ff" strokeWidth="1.4" fill="none" opacity="0.8">
                <path d="M14 14L4 6M14 16L2 16M14 18L4 26M26 14L36 6M26 16L38 16M26 18L36 26" />
            </g>
            <ellipse cx="20" cy="16" rx="7" ry="8" fill="currentColor" stroke="#e9d5ff" strokeWidth="1" />
            <circle cx="17.5" cy="14" r="1.4" fill="#f97316" />
            <circle cx="22.5" cy="14" r="1.4" fill="#f97316" />
        </svg>
    </div>
);

const BATS = [
    { top: '14%', size: 34, dur: 15, delay: 0 },
    { top: '38%', size: 24, dur: 19, delay: 5 },
    { top: '62%', size: 30, dur: 17, delay: 10 },
    { top: '24%', size: 20, dur: 22, delay: 13 },
];

const HalloweenDecor = () => (
    <>
        <style>{`
            @keyframes hwFly {
                0%   { transform: translate(-12vw, 0) scale(1); }
                25%  { transform: translate(25vw, -4vh) scale(1.05); }
                50%  { transform: translate(55vw, 3vh) scale(.95); }
                75%  { transform: translate(85vw, -3vh) scale(1.05); }
                100% { transform: translate(115vw, 0) scale(1); }
            }
            @keyframes hwFlap { 0%,100% { transform: scaleY(1); } 50% { transform: scaleY(.45); } }
            @keyframes hwDrop { 0%,100% { transform: translateY(-10px); } 50% { transform: translateY(26px); } }
            .hw-bat  { position: absolute; left: 0; color: #120a18; opacity: .85; animation: hwFly linear infinite; filter: drop-shadow(0 0 6px rgba(249,115,22,.35)); }
            .hw-bat svg { animation: hwFlap .35s ease-in-out infinite; transform-origin: center; }
            .hw-drop { animation: hwDrop 6s ease-in-out infinite; }
        `}</style>
        <Web className="absolute left-0 top-0 h-28 w-28 text-white/25" />
        <Web className="absolute right-0 top-0 h-28 w-28 text-white/25" style={{ transform: 'scaleX(-1)' }} />
        <Spider className="hw-drop absolute right-10 top-0 sm:right-24" />
        {BATS.map((b, i) => (
            <div key={i} className="hw-bat" style={{ top: b.top, animationDuration: `${b.dur}s`, animationDelay: `${b.delay}s` }}>
                <Bat style={{ width: b.size * 2, height: b.size }} />
            </div>
        ))}
        <Pumpkin className="qs-bob absolute -left-5 bottom-24 h-11 w-11 opacity-90 sm:-left-2 sm:h-16 sm:w-16" />
        <Pumpkin className="qs-bob absolute -right-4 bottom-40 h-9 w-9 opacity-80 sm:-right-1 sm:h-14 sm:w-14" style={{ animationDelay: '1.5s' }} />
    </>
);

// ═════════════════════════════════ YENİ İL ═══════════════════════════════════

const Snowflake = ({ size }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" fill="none" stroke="#fff" strokeWidth="1.6" strokeLinecap="round">
        <path d="M12 2v20M3.3 7l17.4 10M3.3 17L20.7 7M12 2l-2 2M12 2l2 2M12 22l-2-2M12 22l2-2" />
    </svg>
);

const Tree = ({ className, style }) => (
    <svg viewBox="0 0 60 72" className={className} style={style} aria-hidden="true">
        <rect x="26" y="60" width="8" height="10" rx="1.5" fill="#7c4a1e" />
        <path d="M30 6L12 30h8L8 46h9L4 62h52L43 46h9L40 30h8z" fill="#15803d" />
        <path d="M30 6L12 30h8L8 46h9L4 62h26z" fill="#166534" />
        <path d="M30 0l2 4.5 5 .5-3.8 3.3 1.2 4.9L30 10.6 25.6 13.2l1.2-4.9L23 5l5-.5z" fill="#facc15" />
        <circle cx="22" cy="36" r="2.4" fill="#ef4444" /><circle cx="37" cy="27" r="2.2" fill="#facc15" />
        <circle cx="38" cy="50" r="2.6" fill="#38bdf8" /><circle cx="18" cy="55" r="2.4" fill="#facc15" />
        <circle cx="30" cy="42" r="2.2" fill="#f472b6" /><circle cx="44" cy="58" r="2.2" fill="#ef4444" />
    </svg>
);

const Gift = ({ className, style }) => (
    <svg viewBox="0 0 48 48" className={className} style={style} aria-hidden="true">
        <rect x="6" y="18" width="36" height="26" rx="3" fill="#dc2626" />
        <rect x="3" y="12" width="42" height="9" rx="2.5" fill="#ef4444" />
        <rect x="21" y="12" width="6" height="32" fill="#facc15" />
        <path d="M24 12c-4-8-13-8-12-2 1 3 7 3 12 2zM24 12c4-8 13-8 12-2-1 3-7 3-12 2z" fill="#facc15" />
    </svg>
);

const BULB_COLORS = ['#ef4444', '#facc15', '#22c55e', '#38bdf8', '#f472b6'];

const Garland = () => (
    <svg viewBox="0 0 400 26" preserveAspectRatio="none" className="absolute inset-x-0 top-0 h-6 w-full" aria-hidden="true">
        <path d="M0 4 Q25 18 50 4 T100 4 T150 4 T200 4 T250 4 T300 4 T350 4 T400 4" fill="none" stroke="#1f2937" strokeWidth="1.4" />
        {Array.from({ length: 16 }, (_, i) => {
            const x = 12.5 + i * 25;
            const y = i % 2 === 0 ? 12 : 12;
            return (
                <ellipse key={i} cx={x} cy={y} rx="3.2" ry="4.4" fill={BULB_COLORS[i % BULB_COLORS.length]}
                    className="ny-bulb" style={{ animationDelay: `${(i % 4) * 0.35}s` }} />
            );
        })}
    </svg>
);

const NewYearDecor = () => (
    <>
        <style>{`
            @keyframes nyBlink { 0%,100% { opacity: 1; } 50% { opacity: .35; } }
            .ny-bulb { animation: nyBlink 1.4s ease-in-out infinite; filter: drop-shadow(0 0 3px rgba(255,255,255,.6)); }
        `}</style>
        <Garland />
        {scatter(18, 1).map((f, i) => (
            <div key={i} className="qs-fall" style={{ left: f.left, opacity: f.op, animationDuration: `${f.dur}s`, animationDelay: `${f.delay}s`, '--qs-dx': `${f.dx}px` }}>
                <Snowflake size={f.size} />
            </div>
        ))}
        <Tree className="qs-bob absolute -left-4 bottom-24 h-14 w-12 sm:-left-1 sm:h-20 sm:w-16" />
        <Gift className="qs-bob absolute -right-3 bottom-40 h-10 w-10 sm:-right-1 sm:h-14 sm:w-14" style={{ animationDelay: '1.5s' }} />
    </>
);

// ═════════════════════════════════ NOVRUZ ════════════════════════════════════

// Səməni: boşqabda yaşıl cücərti, qırmızı lent
const Semeni = ({ className, style }) => (
    <svg viewBox="0 0 64 60" className={className} style={style} aria-hidden="true">
        {Array.from({ length: 15 }, (_, i) => {
            const x = 12 + i * 2.9;
            const h = 22 + ((i * 7) % 11);
            const lean = ((i % 5) - 2) * 2.2;
            return <path key={i} d={`M${x} 42 Q${x + lean / 2} ${42 - h / 2} ${x + lean} ${42 - h}`} stroke={i % 2 ? '#22c55e' : '#4ade80'} strokeWidth="2.2" fill="none" strokeLinecap="round" />;
        })}
        <rect x="9" y="36" width="46" height="7" rx="2" fill="#dc2626" />
        <path d="M30 39l-4 10M34 39l4 10" stroke="#b91c1c" strokeWidth="2.4" strokeLinecap="round" />
        <ellipse cx="32" cy="48" rx="27" ry="6" fill="#fbbf24" />
        <ellipse cx="32" cy="46.5" rx="22" ry="3.4" fill="#f59e0b" />
    </svg>
);

// Tonqal
const Bonfire = ({ className, style }) => (
    <svg viewBox="0 0 60 64" className={className} style={style} aria-hidden="true">
        <g className="nz-flame">
            <path d="M30 6c6 10 16 16 16 30a16 16 0 0 1-32 0c0-8 4-12 7-16 0 6 3 9 5 9-2-8 0-15 4-23z" fill="#f97316" />
            <path d="M30 24c4 6 9 9 9 16a9 9 0 0 1-18 0c0-4 2-6 4-8 0 3 2 5 3 5-1-5 0-9 2-13z" fill="#facc15" />
        </g>
        <path d="M8 56l44-8M8 48l44 8" stroke="#7c4a1e" strokeWidth="6" strokeLinecap="round" />
    </svg>
);

// Buta (yarpaq formasında ornament)
const Buta = ({ size, color }) => (
    <svg viewBox="0 0 24 32" width={size} height={size * 1.33} aria-hidden="true">
        <path d="M12 31C4 31 2 24 2 19 2 10 10 6 14 1c1 4-1 6 1 8 4 3 7 6 7 12 0 6-4 10-10 10z" fill={color} />
        <circle cx="11" cy="21" r="3.4" fill="none" stroke="#fff7ed" strokeWidth="1.2" opacity=".7" />
    </svg>
);

const Egg = ({ size, color }) => (
    <svg viewBox="0 0 20 26" width={size} height={size * 1.3} aria-hidden="true">
        <path d="M10 1C5 1 1 9 1 15.5S5 25 10 25s9-3 9-9.5S15 1 10 1z" fill={color} />
        <path d="M2 14c3 2 6-2 8 0s5 2 8 0" stroke="#fff" strokeWidth="1.3" fill="none" opacity=".8" />
    </svg>
);

const NZ_COLORS = ['#f59e0b', '#ef4444', '#22c55e', '#facc15', '#f472b6'];

const NovruzDecor = () => (
    <>
        <style>{`
            @keyframes nzFlicker { 0%,100% { transform: scale(1,1); } 33% { transform: scale(.94,1.06); } 66% { transform: scale(1.04,.95); } }
            .nz-flame { transform-origin: 30px 52px; animation: nzFlicker .9s ease-in-out infinite; }
        `}</style>
        {/* Künclərdə buta ornamentləri */}
        <div className="absolute left-1 top-1 rotate-[-25deg] opacity-40"><Buta size={26} color="#f59e0b" /></div>
        <div className="absolute right-1 top-1 rotate-[25deg] scale-x-[-1] opacity-40"><Buta size={26} color="#f59e0b" /></div>
        {/* Yavaş düşən buta və boyanmış yumurtalar */}
        {scatter(12, 2).map((f, i) => (
            <div key={i} className="qs-fall" style={{ left: f.left, opacity: f.op * 0.8, animationDuration: `${f.dur + 6}s`, animationDelay: `${f.delay}s`, '--qs-dx': `${f.dx}px` }}>
                {i % 3 === 0
                    ? <Egg size={f.size} color={NZ_COLORS[i % NZ_COLORS.length]} />
                    : <Buta size={f.size} color={NZ_COLORS[i % NZ_COLORS.length]} />}
            </div>
        ))}
        <Semeni className="qs-bob absolute -left-4 bottom-24 h-12 w-14 sm:-left-1 sm:h-16 sm:w-20" />
        <Bonfire className="absolute -right-3 bottom-40 h-12 w-11 sm:-right-1 sm:h-16 sm:w-14" />
    </>
);

// ═════════════════════════════════ Ümumi ═════════════════════════════════════

const DECOR = { halloween: HalloweenDecor, newyear: NewYearDecor, novruz: NovruzDecor };

export default function SeasonalLayer({ season }) {
    const Decor = DECOR[season];
    if (!Decor) return null;
    return (
        <div className="qs-anim pointer-events-none fixed inset-0 z-[25] overflow-hidden" aria-hidden="true">
            <style>{BASE_CSS}</style>
            <Decor />
        </div>
    );
}

const BANNERS = {
    halloween: { Icon: Pumpkin, title: 'Happy Halloween!', sub: 'Qorxulu dərəcədə dadlı menyu', bg: 'from-[#2a1438] via-[#3b1a4d] to-[#7c2d12]', subCls: 'text-orange-200/90' },
    newyear:   { Icon: Tree, title: 'Yeni iliniz mübarək!', sub: 'Bayram süfrəniz bizdən olsun', bg: 'from-[#0b1a33] via-[#1e3a5f] to-[#7f1d1d]', subCls: 'text-sky-100/90' },
    novruz:    { Icon: Semeni, title: 'Novruz bayramınız mübarək!', sub: 'Bahar süfrəsinə buyurun', bg: 'from-[#0f241a] via-[#14532d] to-[#b45309]', subCls: 'text-amber-100/90' },
};

export function SeasonBanner({ season }) {
    const b = BANNERS[season];
    if (!b) return null;
    const { Icon } = b;
    return (
        <div className={`mb-4 flex items-center gap-3 overflow-hidden rounded-2xl bg-gradient-to-r ${b.bg} px-4 py-3 text-white ring-1 ring-white/10`}>
            <Icon className="h-10 w-10 flex-shrink-0" />
            <div className="min-w-0">
                <div className="text-[15px] font-extrabold tracking-tight">{b.title}</div>
                <div className={`truncate text-xs ${b.subCls}`}>{b.sub}</div>
            </div>
        </div>
    );
}
